<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/b0gia9/cover.jpeg?1684515193358" alt="This image is the cover for the book Sorrow Break up, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sorrow Break up, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p>There were always some strangers struggling at night in the city. Life is a journey where you can leave when you wish. Only when you are alive can you leave behind traces so that you can have no regrets about your youth.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Xi Men, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35fd8dbf